import { cn } from '@/utils/cn'
import { type IconProps, iconVariants } from './common'

export function SettingsIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M15.5 12.0002C15.5 13.9332 13.933 15.5002 12 15.5002C10.067 15.5002 8.5 13.9332 8.5 12.0002C8.5 10.0672 10.067 8.50024 12 8.50024C13.933 8.50024 15.5 10.0672 15.5 12.0002Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.40192 6.57187C4.84964 5.61528 5.17739 4.3921 6.13397 3.83982L7.86602 2.83982C8.82261 2.28753 10.0458 2.61528 10.5981 3.57187C11.2212 4.65107 12.7789 4.65108 13.4019 3.57187C13.9542 2.61529 15.1774 2.28754 16.134 2.83982L17.866 3.83982C18.8226 4.39211 19.1504 5.61529 18.5981 6.57187C17.975 7.65107 18.7538 9.00008 20 9.00008C21.1046 9.00008 22 9.89551 22 11.0001V13.0001C22 14.1047 21.1046 15.0001 20 15.0001C18.7539 15.0001 17.975 16.3491 18.5981 17.4283C19.1504 18.3849 18.8226 19.608 17.866 20.1603L16.134 21.1603C15.1774 21.7126 13.9542 21.3849 13.4019 20.4283C12.7788 19.3491 11.2212 19.3491 10.5981 20.4283C10.0458 21.3849 8.82262 21.7126 7.86603 21.1603L6.13398 20.1603C5.1774 19.608 4.84965 18.3849 5.40193 17.4283C6.02501 16.3491 5.24615 15.0001 4 15.0001C2.89543 15.0001 2 14.1047 2 13.0001V11.0001C2 9.89551 2.89543 9.00008 4 9.00008C5.24616 9.00008 6.025 7.65107 5.40192 6.57187ZM17 12.0002C17 14.7617 14.7614 17.0002 12 17.0002C9.23858 17.0002 7 14.7617 7 12.0002C7 9.23882 9.23858 7.00024 12 7.00024C14.7614 7.00024 17 9.23882 17 12.0002Z"
        fill="currentColor"
      />
    </svg>
  )
}
